import { createSlice } from "@reduxjs/toolkit";
import {
  addLocationV3,
  checkHubStationDelete,
  deleteHubStation,
  deleteLocationV3,
  editLocationV3,
  getAllHubs,
  getAllLocationsV3,
  getGeoLocations,
  getGlobalLocations,
  getLocations,
  getLocationsFromODK,
  getLocationsV3,
  getTrikeLocations,
} from "../APIs/locationsAPI";

const initialState = {
  loading: false,
  backgroundLoading: false,
  error: {},
  status: "idle",
  loggedIn: false,
  locations: [],
  geoLocations: [],
  trikeLocations: [],
  trikeBatteries: [],

  // phase 3
  currentLocation: null,
  locationsList: {
    result: [],
    totalRecords: 0,
  },
  allLocations: [],
  globalLocations: [],
  allHubs: [],
  threeDotsPopoverId: 0,
  deleteLocationModal: {
    visible: false,
    location: {},
  },
  deleteHubStationModal: {
    visible: false,
    hub: {},
  },
  assignHubStation: false,
  showToastMessage: {
    visible: false,
    data: {},
  },
};

export const locationSlice = createSlice({
  name: "locations",
  initialState,
  reducers: {
    updateLocations: (state, action) => {
      state[action.payload.key] = action.payload.value;
    },
  },
  extraReducers(builder) {
    builder.addCase(getLocations.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getLocations.fulfilled, (state, action) => {
      state.loading = false;
      state.status = "fulfilled";
      state.locations = action.payload;
    });
    builder.addCase(getLocations.rejected, (state, action) => {
      state.loading = false;
      state.status = "rejected";
      state.locations = [];
      state.error = action.error;
    });
    builder.addCase(getTrikeLocations.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTrikeLocations.fulfilled, (state, action) => {
      state.loading = false;
      state.status = "fulfilled";
      state.trikeLocations = [action.payload.global_values];
      state.trikeBatteries = [action.payload];
    });
    builder.addCase(getTrikeLocations.rejected, (state, action) => {
      state.loading = false;
      state.status = "rejected";
      state.trikeLocations = [];
      state.error = action.error;
    });

    // get Locations from DB
    builder.addCase(getGeoLocations.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getGeoLocations.fulfilled, (state, action) => {
      state.loading = false;
      state.status = "fulfilled";
      state.geoLocations = action.payload;
    });
    builder.addCase(getGeoLocations.rejected, (state, action) => {
      state.loading = false;
      state.status = "rejected";
      state.geoLocations = [];
      state.error = action.error;
    });

    // get Locations from ODK
    builder.addCase(getLocationsFromODK.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getLocationsFromODK.fulfilled, (state) => {
      state.loading = false;
      state.status = "fulfilled";
    });
    builder.addCase(getLocationsFromODK.rejected, (state, action) => {
      state.loading = false;
      state.status = "rejected";
      state.error = action.error;
    });

    // phase3
    // get locations
    builder.addCase(getLocationsV3.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getLocationsV3.fulfilled, (state, action) => {
      state.loading = false;
      state.status = "fulfilled";
      state.locationsList = action.payload;
    });
    builder.addCase(getLocationsV3.rejected, (state, action) => {
      state.loading = false;
      state.status = "rejected";
      state.error = action.error;
    });

    // add location
    builder.addCase(addLocationV3.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addLocationV3.fulfilled, (state) => {
      state.loading = false;
      state.status = "fulfilled";
    });
    builder.addCase(addLocationV3.rejected, (state, { payload }) => {
      state.loading = false;
      state.status = "rejected";
      state.error = payload;
    });

    // edit location
    builder.addCase(editLocationV3.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(editLocationV3.fulfilled, (state) => {
      state.loading = false;
      state.status = "fulfilled";
    });
    builder.addCase(editLocationV3.rejected, (state, { payload }) => {
      state.loading = false;
      state.status = "rejected";
      state.error = payload;
    });

    // delete location
    builder.addCase(deleteLocationV3.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteLocationV3.fulfilled, (state) => {
      state.loading = false;
      state.status = "fulfilled";
    });
    builder.addCase(deleteLocationV3.rejected, (state, { payload }) => {
      state.loading = false;
      state.status = "rejected";
      state.error = payload;
    });

    // check hub station delete
    builder.addCase(checkHubStationDelete.pending, () => {
      // state.loading = true;
    });
    builder.addCase(checkHubStationDelete.fulfilled, (state) => {
      state.loading = false;
      state.status = "fulfilled";
    });
    builder.addCase(checkHubStationDelete.rejected, (state, { payload }) => {
      // state.loading = false;
      state.status = "rejected";
      state.error = payload;
    });

    // delete hub station
    builder.addCase(deleteHubStation.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteHubStation.fulfilled, (state) => {
      state.loading = false;
      state.status = "fulfilled";
    });
    builder.addCase(deleteHubStation.rejected, (state, { payload }) => {
      state.loading = false;
      state.status = "rejected";
      state.error = payload;
    });

    // get all location
    builder.addCase(getAllLocationsV3.pending, (state) => {
      state.backgroundLoading = true;
    });
    builder.addCase(getAllLocationsV3.fulfilled, (state, action) => {
      state.backgroundLoading = false;
      state.status = "fulfilled";
      state.allLocations = action.payload.data;
    });
    builder.addCase(getAllLocationsV3.rejected, (state, { payload }) => {
      state.backgroundLoading = false;
      state.status = "rejected";
      state.error = payload;
    });

    // get global locations including deleted
    builder.addCase(getGlobalLocations.pending, (state) => {
      state.backgroundLoading = true;
    });
    builder.addCase(getGlobalLocations.fulfilled, (state, action) => {
      state.backgroundLoading = false;
      state.status = "fulfilled";
      state.globalLocations = action.payload.data;
    });
    builder.addCase(getGlobalLocations.rejected, (state, { payload }) => {
      state.backgroundLoading = false;
      state.status = "rejected";
      state.error = payload;
    });

    // get all hub stations
    builder.addCase(getAllHubs.pending, (state) => {
      state.backgroundLoading = true;
    });
    builder.addCase(getAllHubs.fulfilled, (state, action) => {
      state.backgroundLoading = false;
      state.status = "fulfilled";
      state.allHubs = action.payload.data;
    });
    builder.addCase(getAllHubs.rejected, (state, { payload }) => {
      state.backgroundLoading = false;
      state.status = "rejected";
      state.error = payload;
    });
  },
});

export const { updateLocations, locations, trikeLocations } =
  locationSlice.actions;
export default locationSlice.reducer;
